export class Link {
  name: string
  path: string

  constructor (name: string, path: string) {
    this.name = name
    this.path = path
  }
}



// WEBPACK FOOTER //
// ./node_modules/_tslint-loader@3.5.4@tslint-loader!./src/views/client/link.ts